import { DistinctGameStyles } from './distinctGameStyles';
import { QualityGameStyles } from './qualityGameStyles';

export const BrainTrainingGamesStyles = `
    .UFOV-brain-games__screen {
        display: flex;
        flex-direction: column;
        gap: 14px;
        height: var(--UFOV-resolved-app-height);
        margin: 0 auto;
        max-width: 430px;
        min-height: var(--UFOV-resolved-app-height);
        overflow: hidden auto;
        padding:
            calc(env(safe-area-inset-top, 0px) + 14px)
            16px
            max(16px, calc(env(safe-area-inset-bottom, 0px) + 16px));
        width: 100%;
    }

    .UFOV-brain-games__top {
        align-items: center;
        display: flex;
        flex: none;
        gap: 12px;
        justify-content: space-between;
    }

    .UFOV-brain-games__top h1,
    .UFOV-brain-games__play h2 {
        color: var(--UFOV-title);
        font-size: 28px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 0.98;
        margin: 0;
    }

    .UFOV-brain-games__eyebrow,
    .UFOV-brain-games__play-head span,
    .UFOV-brain-games__stat span {
        color: var(--UFOV-muted);
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        letter-spacing: 0.08em;
        line-height: 1;
        text-transform: uppercase;
    }

    .UFOV-brain-games__top-actions {
        display: flex;
        gap: 8px;
    }

    .UFOV-brain-games__icon-button {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(19, 38, 79, 0.12);
        border-radius: 16px;
        box-shadow: 0 12px 28px rgba(43, 55, 90, 0.08);
        color: var(--UFOV-title);
        display: inline-flex;
        height: 46px;
        justify-content: center;
        text-decoration: none;
        width: 46px;
    }

    .UFOV-brain-games__icon-button svg {
        fill: none;
        height: 24px;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 3;
        width: 24px;
    }

    .UFOV-brain-games__play p {
        color: var(--UFOV-muted);
        font-size: 13px;
        font-weight: 600;
        line-height: 1.34;
        margin: 0;
    }

    .UFOV-brain-games__play {
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid rgba(19, 38, 79, 0.1);
        border-radius: 24px;
        box-shadow: 0 18px 44px rgba(43, 55, 90, 0.1);
        display: grid;
        gap: 14px;
        padding: 16px;
    }

    .UFOV-brain-games__play-head {
        display: grid;
        gap: 10px;
    }

    .UFOV-brain-games__play-head div {
        display: grid;
        gap: 6px;
    }

    .UFOV-brain-games__progress {
        background: rgba(19, 38, 79, 0.08);
        border-radius: 999px;
        height: 8px;
        overflow: hidden;
        width: 100%;
    }

    .UFOV-brain-games__progress span {
        background: #35c9c1;
        border-radius: inherit;
        display: block;
        height: 100%;
        min-width: 8px;
        transition: width 260ms cubic-bezier(0.22, 1, 0.36, 1);
    }

    .UFOV-brain-games__play-body {
        display: grid;
        gap: 12px;
    }

    .UFOV-brain-games__play-footer {
        display: flex;
        gap: 10px;
        justify-content: center;
    }

    .UFOV-brain-games__button {
        align-items: center;
        border: 0;
        border-radius: 999px;
        display: inline-flex;
        font: inherit;
        font-size: 14px;
        font-weight: 600;
        justify-content: center;
        min-height: 46px;
        padding: 0 20px;
    }

    .UFOV-brain-games__button.is-primary {
        background: #13264f;
        color: #ffffff;
    }

    .UFOV-brain-games__button.is-secondary {
        background: rgba(19, 38, 79, 0.08);
        color: var(--UFOV-title);
    }

    .UFOV-brain-games__button:disabled {
        opacity: 0.42;
    }

    .UFOV-brain-games__stats {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(auto-fit, minmax(78px, 1fr));
    }

    .UFOV-brain-games__stat {
        background: rgba(19, 38, 79, 0.06);
        border: 1px solid rgba(19, 38, 79, 0.04);
        border-radius: 14px;
        display: grid;
        gap: 4px;
        min-height: 58px;
        padding: 10px;
    }

    .UFOV-brain-games__stat strong {
        color: var(--UFOV-title);
        font-size: 19px;
        font-weight: 600;
        line-height: 1;
    }

    .UFOV-brain-games__notice {
        background: rgba(19, 38, 79, 0.06);
        border-radius: 14px;
        color: var(--UFOV-muted);
        font-size: 13px;
        font-weight: 600;
        line-height: 1.25;
        min-height: 42px;
        padding: 12px;
        text-align: center;
    }

    .UFOV-brain-games__notice.is-good {
        background: rgba(53, 201, 193, 0.16);
        color: #116963;
    }

    .UFOV-brain-games__notice.is-warn {
        background: rgba(255, 122, 102, 0.14);
        color: #a33b2d;
    }

    .UFOV-brain-games__memory-grid {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .UFOV-brain-games__memory-card,
    .UFOV-brain-games__matrix-cell,
    .UFOV-brain-games__sequence-pad,
    .UFOV-brain-games__schulte-grid button,
    .UFOV-brain-games__search-grid button,
    .UFOV-brain-games__odd-grid button {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(19, 38, 79, 0.12);
        border-radius: 16px;
        color: var(--UFOV-title);
        display: inline-flex;
        font: inherit;
        font-size: 24px;
        font-weight: 600;
        justify-content: center;
        min-height: 54px;
        position: relative;
        transition:
            background-color 180ms ease,
            border-color 180ms ease,
            color 180ms ease,
            transform 180ms ease;
    }

    .UFOV-brain-games__memory-card {
        aspect-ratio: 1;
        background: #2f6fed;
        color: #ffffff;
        font-size: 28px;
        overflow: hidden;
    }

    .UFOV-brain-games__memory-card::before {
        background: transparent;
        content: "";
        inset: 0;
        opacity: 0.95;
        position: absolute;
    }

    .UFOV-brain-games__memory-card.is-open {
        background: #ffffff;
        border-color: color-mix(in srgb, var(--game-tone) 55%, #ffffff);
        color: var(--UFOV-title);
        transform: translateY(-1px);
    }

    .UFOV-brain-games__memory-card.is-open::before {
        background: color-mix(in srgb, var(--game-tone) 16%, #ffffff);
        opacity: 1;
    }

    .UFOV-brain-games__memory-card.is-matched {
        border-color: var(--game-tone);
        color: #083c39;
    }

    .UFOV-brain-games__matrix,
    .UFOV-brain-games__odd-grid {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }

    .UFOV-brain-games__matrix-cell {
        aspect-ratio: 1;
        min-height: 0;
    }

    .UFOV-brain-games__matrix-cell.is-lit,
    .UFOV-brain-games__matrix-cell.is-picked,
    .UFOV-brain-games__sequence-pad.is-lit {
        background: #35c9c1;
        border-color: #35c9c1;
        color: #ffffff;
        transform: translateY(-1px) scale(1.02);
    }

    .UFOV-brain-games__matrix-cell.is-correct {
        background: rgba(53, 201, 193, 0.22);
        border-color: #35c9c1;
    }

    .UFOV-brain-games__matrix-cell.is-wrong {
        background: rgba(255, 122, 102, 0.2);
        border-color: #ff7a66;
    }

    .UFOV-brain-games__matrix-cell.is-missed {
        background: rgba(242, 192, 75, 0.24);
        border-color: #f2c04b;
    }

    .UFOV-brain-games__sequence-grid {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .UFOV-brain-games__sequence-pad {
        aspect-ratio: 1;
        color: #ffffff;
        font-size: 25px;
        overflow: hidden;
    }

    .UFOV-brain-games__sequence-pad.is-pad-0 { background: #13264f; }
    .UFOV-brain-games__sequence-pad.is-pad-1 { background: #147d76; }
    .UFOV-brain-games__sequence-pad.is-pad-2 { background: #9a5a0a; }
    .UFOV-brain-games__sequence-pad.is-pad-3 { background: #88406f; }

    .UFOV-brain-games__nback-lane {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .UFOV-brain-games__nback-lane span {
        align-items: center;
        background: rgba(19, 38, 79, 0.07);
        border-radius: 14px;
        color: var(--UFOV-muted);
        display: flex;
        font-size: 18px;
        font-weight: 600;
        justify-content: center;
        min-height: 42px;
    }

    .UFOV-brain-games__nback-lane span.is-current {
        background: rgba(53, 201, 193, 0.16);
        color: var(--UFOV-title);
    }

    .UFOV-brain-games__nback-card,
    .UFOV-brain-games__stroop-word {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(19, 38, 79, 0.1);
        border-radius: 22px;
        color: var(--UFOV-title);
        display: flex;
        font-size: 64px;
        font-weight: 600;
        justify-content: center;
        line-height: 1;
        min-height: 142px;
    }

    .UFOV-brain-games__split-actions,
    .UFOV-brain-games__color-grid {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .UFOV-brain-games__color-grid .UFOV-brain-games__button {
        gap: 8px;
    }

    .UFOV-brain-games__color-grid span {
        border-radius: 999px;
        display: inline-block;
        height: 14px;
        width: 14px;
    }

    .UFOV-brain-games__schulte-grid,
    .UFOV-brain-games__search-grid {
        display: grid;
        gap: 6px;
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }

    .UFOV-brain-games__search-grid {
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }

    .UFOV-brain-games__schulte-grid button,
    .UFOV-brain-games__search-grid button {
        aspect-ratio: 1;
        background: #ffffff;
        font-size: 18px;
        min-height: 0;
    }

    .UFOV-brain-games__schulte-grid button.is-done {
        background: transparent;
        box-shadow: none;
        opacity: 0.5;
    }

    .UFOV-brain-games__target-chip {
        align-items: center;
        background: rgba(19, 38, 79, 0.06);
        border-radius: 16px;
        color: var(--UFOV-muted);
        display: flex;
        font-size: 14px;
        font-weight: 600;
        gap: 8px;
        justify-content: center;
        min-height: 46px;
    }

    .UFOV-brain-games__target-chip strong {
        color: var(--UFOV-title);
        font-size: 24px;
        line-height: 1;
    }

    .UFOV-brain-games__search-grid .is-rotated {
        display: inline-block;
        transform: rotate(90deg);
    }

    .UFOV-brain-games__search-grid button.is-muted {
        color: rgba(19, 38, 79, 0.48);
    }

    .UFOV-brain-games__search-grid button.is-small span {
        font-size: 0.8em;
    }

    .UFOV-brain-games__search-grid button.is-picked:not(.is-target),
    .UFOV-brain-games__odd-grid button.is-picked:not(.is-target) {
        background: rgba(255, 122, 102, 0.16);
        border-color: #ff7a66;
        color: #a33b2d;
    }

    .UFOV-brain-games__search-grid button.is-target,
    .UFOV-brain-games__odd-grid button.is-target {
        background: rgba(53, 201, 193, 0.2);
        border-color: #35c9c1;
        color: #116963;
        box-shadow: inset 0 0 0 2px rgba(53, 201, 193, 0.28);
    }

    .UFOV-brain-games__odd-grid button {
        aspect-ratio: 1;
        font-size: 27px;
        min-height: 0;
    }

    .UFOV-brain-games__odd-grid button.is-rotated {
        transform: rotate(-4deg);
    }

    .UFOV-brain-games__odd-grid button.is-faded {
        color: rgba(19, 38, 79, 0.55);
    }

    .UFOV-brain-games__trail-board {
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(19, 38, 79, 0.1);
        border-radius: 24px;
        overflow: hidden;
        position: relative;
    }

    .UFOV-brain-games__trail-board svg {
        height: 100%;
        inset: 0;
        position: absolute;
        width: 100%;
    }

    .UFOV-brain-games__trail-board line {
        stroke: #35c9c1;
        stroke-linecap: round;
        stroke-width: 2.4;
    }

    .UFOV-brain-games__trail-board button {
        align-items: center;
        background: #13264f;
        border: 0;
        border-radius: 999px;
        color: #ffffff;
        display: inline-flex;
        font: inherit;
        font-size: 17px;
        font-weight: 600;
        height: 42px;
        justify-content: center;
        position: absolute;
        transform: translate(-50%, -50%);
        width: 42px;
        z-index: 1;
    }

    .UFOV-brain-games__trail-board button.is-next {
        background: #35c9c1;
        color: #083c39;
        box-shadow: 0 0 0 7px rgba(53, 201, 193, 0.18);
    }

    .UFOV-brain-games__trail-board button.is-done {
        background: #d7f6f2;
        color: #116963;
    }

    .UFOV-brain-games__trail-grid {
        display: grid;
        gap: 12px;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        justify-self: center;
        max-width: 380px;
        width: 100%;
    }

    .UFOV-brain-games__trail-grid button {
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 20px;
        box-shadow: 0 14px 24px rgba(38, 48, 79, 0.1);
        color: var(--brain-ink);
        font: inherit;
        font-size: clamp(24px, 8vw, 34px);
        font-weight: 600;
        min-height: 0;
        padding: 0;
        transition:
            background-color 150ms ease,
            box-shadow 150ms ease,
            color 150ms ease,
            transform 150ms ease;
    }

    .UFOV-brain-games__trail-grid button.is-done {
        background: #dff7ed;
        color: #1f6f52;
        transform: scale(0.97);
    }

    .UFOV-brain-games__trail-grid button.is-missed {
        background: #ffe0e5;
        color: #b4323a;
        box-shadow:
            0 0 0 5px rgba(255, 154, 168, 0.2),
            0 14px 24px rgba(38, 48, 79, 0.1);
    }

    .UFOV-brain-games__screen {
        --brain-ink: #26304f;
        --brain-pink: #ff6f91;
        --brain-orange: #ffb454;
        --brain-yellow: #ffe66d;
        --brain-green: #4de6b3;
        --brain-blue: #54c7ff;
        --brain-purple: #b884ff;
        background: #f5f5f5;
        color: var(--brain-ink);
        gap: 10px;
        overflow: hidden;
        position: relative;
    }

    .UFOV-brain-games__screen.is-plain-game {
        --brain-ink: #1f2937;
        background: #f5f5f5;
    }

    .UFOV-brain-games__screen.is-plain-game .UFOV-brain-games__top-mark {
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.08);
        color: #1f2937;
    }

    .UFOV-brain-games__screen button,
    .UFOV-brain-games__screen strong,
    .UFOV-brain-games__screen li,
    .UFOV-brain-games__screen span {
        font-weight: 600;
        letter-spacing: 0;
    }

    .UFOV-brain-games__top {
        display: grid;
        gap: 10px;
        grid-template-columns: 46px minmax(0, 1fr) auto;
        min-height: 48px;
        position: relative;
        z-index: 30;
    }

    .UFOV-brain-games__top-spacer {
        align-items: center;
        display: flex;
        gap: 6px;
        justify-content: center;
        min-width: 1px;
    }

    .UFOV-brain-games__level {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 999px;
        box-shadow: 0 12px 24px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
        display: inline-flex;
        gap: 5px;
        height: 36px;
        padding: 0 12px;
    }

    .UFOV-brain-games__level span {
        color: #7d879c;
        font-size: 10px;
        line-height: 1;
    }

    .UFOV-brain-games__level strong {
        font-size: 17px;
        line-height: 1;
    }

    .UFOV-brain-games__hud {
        align-items: center;
        display: flex;
        gap: 6px;
        justify-content: center;
        min-width: 0;
    }

    .UFOV-brain-games__hud-pill {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 999px;
        box-shadow: 0 12px 24px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
        display: inline-flex;
        font-size: 17px;
        font-weight: 600;
        gap: 5px;
        height: 36px;
        justify-content: center;
        line-height: 1;
        min-width: 50px;
        padding: 0 10px;
    }

    .UFOV-brain-games__hud-pill svg {
        fill: currentColor;
        height: 13px;
        width: 13px;
    }

    .UFOV-brain-games__hud-pill.is-score {
        min-width: 62px;
    }

    .UFOV-brain-games__hud-pill.is-elapsed {
        min-width: 66px;
    }

    .UFOV-brain-games__top-mark,
    .UFOV-brain-games__icon-button {
        align-items: center;
        border-radius: 999px;
        display: inline-flex;
        height: 46px;
        justify-content: center;
        width: 46px;
    }

    .UFOV-brain-games__top-mark {
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        box-shadow: 0 12px 24px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
    }

    .UFOV-brain-games__top-mark svg {
        height: 23px;
        width: 23px;
    }

    .UFOV-brain-games__top-actions {
        justify-self: end;
        gap: 10px;
    }

    .UFOV-brain-games__run-timer {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 999px;
        box-shadow: 0 12px 24px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
        display: inline-flex;
        font-size: 20px;
        font-weight: 600;
        height: 38px;
        justify-content: center;
        justify-self: center;
        line-height: 1;
        min-width: 62px;
        padding: 0 12px;
    }

    .UFOV-brain-games__finish-run {
        align-self: center;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.12);
        border-radius: 999px;
        box-shadow: 0 10px 20px rgba(38, 48, 79, 0.1);
        color: var(--brain-ink);
        flex: none;
        font: inherit;
        font-size: 13px;
        font-weight: 600;
        min-height: 42px;
        padding: 0 22px;
        transition: transform 140ms ease, box-shadow 140ms ease;
    }

    .UFOV-brain-games__finish-run:active {
        box-shadow: 0 5px 12px rgba(38, 48, 79, 0.08);
        transform: scale(0.96);
    }

    .UFOV-brain-games__path-streak,
    .UFOV-brain-games__streak-number,
    .UFOV-brain-games__odds-streak {
        display: none;
    }

    .UFOV-brain-games__icon-button {
        background: rgba(255, 255, 255, 0.82);
        border: 1px solid rgba(38, 48, 79, 0.08);
        box-shadow: 0 12px 24px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
        padding: 0;
    }

    .UFOV-brain-games__icon-button svg,
    .UFOV-brain-games__button svg,
    .UFOV-brain-games__nback-card svg,
    .UFOV-brain-games__stroop-word svg,
    .UFOV-brain-games__tutorial svg {
        fill: currentColor;
        height: 24px;
        stroke: none;
        width: 24px;
    }

    .UFOV-brain-games__play-head,
    .UFOV-brain-games__progress,
    .UFOV-brain-games__play-footer,
    .UFOV-brain-games__stats,
    .UFOV-brain-games__notice,
    .UFOV-brain-games__target-chip {
        display: none;
    }

    .UFOV-brain-games__play {
        background: transparent;
        border: 0;
        border-radius: 0;
        box-shadow: none;
        display: flex;
        flex: 1 1 auto;
        min-height: 0;
        padding: 0;
    }

    .UFOV-brain-games__play.is-disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .UFOV-brain-games__result {
        background: #f6f6f7;
        display: block;
        inset: 0;
        padding: 0;
        pointer-events: auto;
        position: absolute;
        z-index: 60;
    }

    .UFOV-brain-games__result-dialog {
        background: #f6f6f7;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        height: 100%;
        margin: 0 auto;
        max-width: 430px;
        min-height: 0;
        padding: 18px 18px max(20px, env(safe-area-inset-bottom));
        width: 100%;
    }

    .UFOV-brain-games__result-head {
        align-items: center;
        display: flex;
        justify-content: center;
        min-height: 42px;
    }

    .UFOV-brain-games__result-head > span:empty {
        display: none;
    }

    .UFOV-brain-games__result-level {
        background: #e8eaee;
        border-radius: 999px;
        color: #17233a;
        font-size: 14px;
        font-weight: 600;
        padding: 9px 12px;
    }

    .UFOV-brain-games__result-stage {
        align-content: center;
        display: grid;
        gap: 22px;
        min-height: 0;
        overflow-y: auto;
        padding: 12px 0;
    }

    .UFOV-brain-games__result-summary {
        display: grid;
        gap: 8px;
        justify-items: center;
        text-align: center;
    }

    .UFOV-brain-games__result-summary h1 {
        color: #17233a;
        font-size: 36px;
        font-weight: 600;
        line-height: 1;
        margin: 0;
    }

    .UFOV-brain-games__result-summary p {
        color: #778196;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.2;
        margin: 0;
    }

    .UFOV-brain-games__result-metrics {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        pointer-events: auto;
        width: 100%;
    }

    .UFOV-brain-games__personal-best {
        align-items: center;
        background: #ffffff;
        border: 1px solid #dfe3e9;
        border-radius: 12px;
        box-shadow: 0 10px 24px rgba(27, 38, 59, 0.06);
        display: flex;
        justify-content: space-between;
        min-height: 68px;
        padding: 12px 14px;
    }

    .UFOV-brain-games__personal-best > div {
        display: grid;
        gap: 3px;
        text-align: left;
    }

    .UFOV-brain-games__personal-best small {
        color: #6b7280;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.1;
    }

    .UFOV-brain-games__personal-best strong {
        color: #17233a;
        font-size: 27px;
        font-weight: 600;
        line-height: 1;
    }

    .UFOV-brain-games__personal-best > span {
        background: #ddf7e8;
        border: 1px solid #b9e4ce;
        border-radius: 999px;
        color: #16724f;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        padding: 8px 10px;
        white-space: nowrap;
    }

    .UFOV-brain-games__personal-best.is-new {
        border-color: #b9e4ce;
        box-shadow: 0 10px 24px rgba(22, 114, 79, 0.1);
    }

    .UFOV-brain-games__result-metrics > span {
        align-items: center;
        background: #ffffff;
        border: 1px solid #dfe3e9;
        border-radius: 8px;
        box-shadow: 0 10px 24px rgba(27, 38, 59, 0.06);
        color: #243652;
        display: grid;
        gap: 7px;
        justify-items: center;
        min-height: 120px;
        padding: 14px 10px;
    }

    .UFOV-brain-games__result-metrics > span:last-child:nth-child(odd) {
        grid-column: 1 / -1;
    }

    .UFOV-brain-games__result-metrics i {
        align-items: center;
        background: #edf7f5;
        border-radius: 50%;
        color: #22a38b;
        display: inline-flex;
        height: 40px;
        justify-content: center;
        width: 40px;
    }

    .UFOV-brain-games__result-metrics i svg {
        height: 20px;
        width: 20px;
    }

    .UFOV-brain-games__result-metrics > span.is-streak i {
        background: #fff4d8;
        color: #d69416;
    }

    .UFOV-brain-games__result-metrics > span.is-mistakes i {
        background: #fdebec;
        color: #d95361;
    }

    .UFOV-brain-games__result-metrics > span.is-elapsed i,
    .UFOV-brain-games__result-metrics > span.is-duration i {
        background: #ebf1fc;
        color: #416fc8;
    }

    .UFOV-brain-games__result-metrics small {
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.1;
        text-align: center;
    }

    .UFOV-brain-games__result-metrics b {
        color: #17233a;
        font-size: 27px;
        font-weight: 600;
        line-height: 1;
    }

    .UFOV-brain-games__result-change {
        align-items: center;
        background: #ffffff;
        border: 1px solid #d9e9e5;
        border-radius: 999px;
        box-shadow: 0 8px 20px rgba(27, 38, 59, 0.05);
        color: #1e8e78;
        display: grid;
        gap: 1px 10px;
        grid-template-columns: auto auto;
        justify-content: center;
        justify-self: center;
        min-height: 50px;
        padding: 7px 20px;
    }

    .UFOV-brain-games__result-change > span {
        font-size: 25px;
        grid-row: 1 / span 2;
        line-height: 1;
    }

    .UFOV-brain-games__result-change strong {
        font-size: 17px;
        font-weight: 600;
        line-height: 1.1;
    }

    .UFOV-brain-games__result-change small {
        color: #778196;
        font-size: 11px;
        font-weight: 600;
        line-height: 1;
    }

    .UFOV-brain-games__result-change.is-down {
        border-color: #eadcdf;
        color: #bc5363;
    }

    .UFOV-brain-games__result-change.is-same {
        border-color: #dfe3e9;
        color: #778196;
    }

    .UFOV-brain-games__result-actions {
        display: grid;
        gap: 10px;
        padding-top: 10px;
    }

    .UFOV-brain-games__result-actions button {
        align-items: center;
        display: inline-flex;
        font: inherit;
        font-size: 15px;
        font-weight: 600;
        min-height: 54px;
        justify-content: center;
        pointer-events: auto;
        width: 100%;
    }

    .UFOV-brain-games__result-actions button.is-primary {
        background: #111827;
        border: 1px solid #111827;
        border-radius: 8px;
        box-shadow: 0 14px 26px rgba(17, 24, 39, 0.16);
        color: #ffffff;
    }

    .UFOV-brain-games__result-actions button.is-secondary {
        background: transparent;
        border: 0;
        color: #667085;
        min-height: 38px;
    }

    @media (max-height: 650px) {
        .UFOV-brain-games__result-dialog {
            padding: 10px 16px 12px;
        }

        .UFOV-brain-games__result-head {
            min-height: 34px;
        }

        .UFOV-brain-games__result-stage {
            gap: 12px;
            padding: 4px 0;
        }

        .UFOV-brain-games__result-summary {
            gap: 5px;
        }

        .UFOV-brain-games__result-summary h1 {
            font-size: 29px;
        }

        .UFOV-brain-games__result-summary p {
            font-size: 15px;
        }

        .UFOV-brain-games__result-metrics > span {
            gap: 4px;
            min-height: 91px;
            padding: 8px;
        }

        .UFOV-brain-games__personal-best {
            min-height: 58px;
            padding: 9px 12px;
        }

        .UFOV-brain-games__personal-best strong {
            font-size: 23px;
        }

        .UFOV-brain-games__result-metrics i {
            height: 32px;
            width: 32px;
        }

        .UFOV-brain-games__result-metrics i svg {
            height: 16px;
            width: 16px;
        }

        .UFOV-brain-games__result-metrics b {
            font-size: 23px;
        }

        .UFOV-brain-games__result-change {
            min-height: 44px;
            padding: 5px 16px;
        }

        .UFOV-brain-games__result-actions {
            gap: 2px;
            padding-top: 4px;
        }

        .UFOV-brain-games__result-actions button.is-primary {
            min-height: 48px;
        }

        .UFOV-brain-games__result-actions button.is-secondary {
            min-height: 32px;
        }
    }

    .UFOV-brain-games__play.is-good {
        --play-glow: rgba(77, 230, 179, 0.42);
    }

    .UFOV-brain-games__play.is-miss {
        --play-glow: rgba(255, 111, 145, 0.36);
    }

    .UFOV-brain-games__play-body {
        align-content: center;
        display: grid;
        flex: 1 1 auto;
        gap: 14px;
        min-height: 0;
    }

    .UFOV-brain-games__button {
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 999px;
        box-shadow: 0 14px 24px rgba(38, 48, 79, 0.1);
        color: var(--brain-ink);
        font-size: 0;
        min-height: 58px;
        padding: 0;
    }

    .UFOV-brain-games__button.is-primary,
    .UFOV-brain-games__button.is-secondary {
        background: #ffffff;
        color: var(--brain-ink);
    }

    .UFOV-brain-games__button svg {
        height: 28px;
        width: 28px;
    }

    .UFOV-brain-games__memory-grid,
    .UFOV-brain-games__matrix,
    .UFOV-brain-games__sequence-grid,
    .UFOV-brain-games__odd-grid {
        gap: 9px;
    }

    .UFOV-brain-games__memory-grid {
        gap: 7px;
        justify-self: center;
        max-width: 332px;
        width: 100%;
    }

    .UFOV-brain-games__memory-card,
    .UFOV-brain-games__matrix-cell,
    .UFOV-brain-games__sequence-pad,
    .UFOV-brain-games__schulte-grid button,
    .UFOV-brain-games__search-grid button,
    .UFOV-brain-games__odd-grid button {
        border: 0;
        border-radius: 18px;
        box-shadow: 0 10px 20px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
        font-weight: 600;
    }

    .UFOV-brain-games__memory-card {
        aspect-ratio: 3 / 4;
        background: transparent;
        border: 0;
        border-radius: 15px;
        box-shadow: none;
        overflow: visible;
        padding: 0;
        perspective: 900px;
    }

    .UFOV-brain-games__memory-card::before {
        content: none;
    }

    .UFOV-brain-games__memory-card-inner {
        height: 100%;
        inset: 0;
        position: absolute;
        transform-style: preserve-3d;
        transition: transform 520ms cubic-bezier(0.22, 0.72, 0.25, 1);
        width: 100%;
    }

    .UFOV-brain-games__memory-card-face {
        align-items: center;
        backface-visibility: hidden;
        border-radius: 15px;
        display: flex;
        inset: 0;
        justify-content: center;
        overflow: hidden;
        position: absolute;
    }

    .UFOV-brain-games__memory-card-face.is-back {
        background: #2f6fed;
        border: 3px solid #ffffff;
        box-shadow:
            0 11px 20px rgba(38, 48, 79, 0.16),
            inset 0 0 0 3px rgba(255, 255, 255, 0.18);
    }

    .UFOV-brain-games__memory-card-face.is-front {
        background: #ffffff;
        border: 2px solid #dce3ee;
        box-shadow: 0 11px 20px rgba(38, 48, 79, 0.13);
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__memory-card.is-open {
        background: transparent;
        border: 0;
        box-shadow: none;
        transform: none;
    }

    .UFOV-brain-games__memory-card.is-open .UFOV-brain-games__memory-card-inner {
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__memory-card img,
    .UFOV-brain-games__search-grid img,
    .UFOV-brain-games__odd-grid img,
    .UFOV-brain-games__target-orb img {
        display: block;
        height: 78%;
        object-fit: contain;
        pointer-events: none;
        position: relative;
        width: 78%;
        z-index: 1;
    }

    .UFOV-brain-games__memory-card .UFOV-brain-games__memory-card-back-logo {
        height: auto;
        opacity: 0.96;
        width: 55%;
    }

    .UFOV-brain-games__memory-card.is-matched {
        background: transparent;
        outline: 0;
    }

    .UFOV-brain-games__memory-card.is-correct .UFOV-brain-games__memory-card-face.is-front,
    .UFOV-brain-games__memory-card.is-matched .UFOV-brain-games__memory-card-face.is-front {
        border-color: #24a06b;
        box-shadow:
            0 0 0 5px rgba(36, 160, 107, 0.16),
            0 11px 20px rgba(38, 48, 79, 0.13);
    }

    .UFOV-brain-games__memory-card.is-wrong .UFOV-brain-games__memory-card-face.is-front {
        border-color: #e5484d;
        box-shadow:
            0 0 0 5px rgba(229, 72, 77, 0.15),
            0 11px 20px rgba(38, 48, 79, 0.13);
    }

    .UFOV-brain-games__memory-card.is-correct,
    .UFOV-brain-games__memory-card.is-wrong {
        animation: UFOV-brain-button-press 400ms ease;
    }

    .UFOV-brain-games__path-game {
        align-content: center;
        display: grid;
        gap: 13px;
        justify-items: center;
    }

    .UFOV-brain-games__path-grid {
        display: grid;
        gap: 6px;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        width: 100%;
    }

    .UFOV-brain-games__path-grid-wrap {
        justify-self: center;
        max-width: 390px;
        perspective: 900px;
        position: relative;
        width: 100%;
    }

    .UFOV-brain-games__path-countdown {
        align-items: center;
        color: #18243d;
        display: flex;
        font-size: 72px;
        font-weight: 600;
        inset: 0;
        justify-content: center;
        line-height: 1;
        pointer-events: none;
        position: absolute;
        z-index: 3;
    }

    .UFOV-brain-games__path-grid.is-countdown {
        opacity: 0.42;
    }

    .UFOV-brain-games__path-streak {
        color: #1f2937;
        font-size: 32px;
        font-weight: 600;
        justify-self: center;
        line-height: 1;
    }

    .UFOV-brain-games__path-cell {
        aspect-ratio: 1;
        background: transparent;
        border: 0;
        border-radius: 10px;
        box-shadow: none;
        min-height: 0;
        opacity: 1;
        padding: 0;
        perspective: 600px;
        position: relative;
    }

    .UFOV-brain-games__path-cell:disabled {
        cursor: default;
        opacity: 1;
    }

    .UFOV-brain-games__path-cell-inner {
        height: 100%;
        inset: 0;
        position: absolute;
        transform: rotateY(180deg);
        transform-style: preserve-3d;
        transition: transform 520ms cubic-bezier(0.22, 0.72, 0.25, 1);
        width: 100%;
    }

    .UFOV-brain-games__path-grid.is-preview .UFOV-brain-games__path-cell-inner {
        transform: rotateY(0deg);
    }

    .UFOV-brain-games__path-cell-face {
        backface-visibility: hidden;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 10px;
        box-shadow: 0 8px 16px rgba(38, 48, 79, 0.06);
        inset: 0;
        position: absolute;
        transition: background-color 180ms ease, box-shadow 180ms ease;
    }

    .UFOV-brain-games__path-cell-face.is-front.is-path {
        background: #72c7ff;
        border-color: rgba(47, 111, 237, 0.2);
        box-shadow: 0 0 0 4px rgba(114, 199, 255, 0.22);
    }

    .UFOV-brain-games__path-cell-face.is-back {
        transform: rotateY(180deg);
    }

    .UFOV-brain-games__path-cell.is-picked .UFOV-brain-games__path-cell-face.is-back {
        background: #8ee6c2;
        border-color: rgba(36, 160, 107, 0.24);
        box-shadow: 0 0 0 4px rgba(142, 230, 194, 0.24);
    }

    .UFOV-brain-games__path-cell.is-failed .UFOV-brain-games__path-cell-face.is-back {
        background: #ff9aa8;
        border-color: rgba(229, 72, 77, 0.24);
        box-shadow: 0 0 0 5px rgba(255, 154, 168, 0.26);
    }

    .UFOV-brain-games__matrix-cell {
        background: #ffffff;
    }

    .UFOV-brain-games__matrix-cell:nth-child(5n + 1) {
        background: #fff0a8;
    }

    .UFOV-brain-games__matrix-cell:nth-child(5n + 2) {
        background: #d9f8ff;
    }

    .UFOV-brain-games__matrix-cell:nth-child(5n + 3) {
        background: #ffe1ef;
    }

    .UFOV-brain-games__matrix-cell:nth-child(5n + 4) {
        background: #dffbe9;
    }

    .UFOV-brain-games__matrix-cell.is-lit,
    .UFOV-brain-games__matrix-cell.is-picked {
        background: var(--brain-blue);
        box-shadow: 0 0 0 6px rgba(77, 230, 179, 0.22);
        color: #ffffff;
        transform: translateY(-1px) scale(1.03);
    }

    .UFOV-brain-games__matrix-cell.is-correct,
    .UFOV-brain-games__search-grid button.is-target,
    .UFOV-brain-games__odd-grid button.is-target {
        background: #cff9e9;
        box-shadow: 0 0 0 5px rgba(77, 230, 179, 0.22);
    }

    .UFOV-brain-games__matrix-cell.is-wrong,
    .UFOV-brain-games__search-grid button.is-picked:not(.is-target),
    .UFOV-brain-games__odd-grid button.is-picked:not(.is-target) {
        background: #ffd8e4;
        box-shadow: 0 0 0 5px rgba(255, 111, 145, 0.18);
    }

    .UFOV-brain-games__matrix-cell.is-missed {
        background: #fff3b7;
        box-shadow: 0 0 0 5px rgba(255, 230, 109, 0.22);
    }

    .UFOV-brain-games__sequence-pad {
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 24px;
        box-shadow: 0 14px 24px rgba(38, 48, 79, 0.1);
        min-height: 0;
    }

    .UFOV-brain-games__sequence-pad span {
        background: #dbe2ee;
        border-radius: 50%;
        display: block;
        height: auto;
        aspect-ratio: 1;
        transition:
            background-color 240ms ease,
            transform 400ms ease;
        width: 28%;
    }

    .UFOV-brain-games__sequence-pad.is-lit {
        background: #eaf1ff;
        border-color: rgba(47, 111, 237, 0.42);
        box-shadow:
            0 0 0 6px rgba(47, 111, 237, 0.13),
            0 18px 30px rgba(38, 48, 79, 0.14);
        scale: 1.04;
    }

    .UFOV-brain-games__sequence-pad.is-lit span {
        background: #2f6fed;
        transform: scale(1.35);
    }

    .UFOV-brain-games__sequence-pad.is-correct {
        background: #e0f7e9;
        border-color: rgba(36, 160, 107, 0.48);
        box-shadow: 0 0 0 6px rgba(36, 160, 107, 0.14);
    }

    .UFOV-brain-games__sequence-pad.is-correct span {
        background: #24a06b;
        transform: scale(1.25);
    }

    .UFOV-brain-games__sequence-pad.is-wrong {
        background: #ffe6e8;
        border-color: rgba(229, 72, 77, 0.5);
        box-shadow: 0 0 0 6px rgba(229, 72, 77, 0.13);
    }

    .UFOV-brain-games__sequence-pad.is-wrong span {
        background: #e5484d;
        transform: scale(1.25);
    }

    .UFOV-brain-games__nback-card,
    .UFOV-brain-games__stroop-word {
        background: transparent;
        border: 0;
        box-shadow: none;
        color: var(--brain-ink);
        font-size: clamp(58px, 22vw, 104px);
        font-weight: 600;
        min-height: 180px;
        text-shadow: 0 10px 20px rgba(38, 48, 79, 0.1);
    }

    .UFOV-brain-games__stroop-word.is-medium {
        font-size: 58px;
    }

    .UFOV-brain-games__stroop-word.is-long {
        font-size: 46px;
    }

    .UFOV-brain-games__stroop-word.is-extra-long {
        font-size: 36px;
    }

    .UFOV-brain-games__nback-card svg,
    .UFOV-brain-games__stroop-word svg {
        height: 72px;
        width: 72px;
    }

    .UFOV-brain-games__split-actions,
    .UFOV-brain-games__color-grid {
        gap: 12px;
    }

    .UFOV-brain-games__streak-number {
        color: #1f2937;
        font-size: 32px;
        font-weight: 600;
        justify-self: center;
        line-height: 1;
    }

    .UFOV-brain-games__color-button {
        aspect-ratio: 1;
        background: var(--swatch);
        border: 8px solid #ffffff;
        border-radius: 22px;
        box-shadow: 0 12px 22px rgba(38, 48, 79, 0.1);
        min-height: 76px;
    }

    .UFOV-brain-games__schulte-grid,
    .UFOV-brain-games__search-grid {
        gap: 8px;
    }

    .UFOV-brain-games__schulte-grid button {
        background: #ffffff;
        font-size: 18px;
    }

    .UFOV-brain-games__schulte-grid button.is-done {
        background: transparent;
        box-shadow: none;
        opacity: 0.5;
    }

    .UFOV-brain-games__target-orb {
        align-items: center;
        aspect-ratio: 1;
        background: #fff0a8;
        border-radius: 999px;
        box-shadow: 0 14px 26px rgba(84, 199, 255, 0.18);
        display: flex;
        justify-content: center;
        justify-self: center;
        width: min(116px, 34vw);
    }

    .UFOV-brain-games__search-grid button,
    .UFOV-brain-games__odd-grid button {
        background: rgba(255, 255, 255, 0.78);
        min-height: 0;
    }

    .UFOV-brain-games__search-grid button.is-muted,
    .UFOV-brain-games__odd-grid button.is-faded {
        opacity: 0.7;
    }

    .UFOV-brain-games__search-grid img.is-rotated,
    .UFOV-brain-games__odd-grid button.is-rotated img {
        transform: rotate(9deg);
    }

    .UFOV-brain-games__flanker-game {
        align-content: center;
        display: grid;
        gap: 22px;
        justify-items: center;
    }

    .UFOV-brain-games__flanker-row {
        align-items: center;
        display: flex;
        gap: clamp(12px, 4vw, 22px);
        justify-content: center;
        justify-self: stretch;
        max-width: 336px;
        width: 100%;
    }

    .UFOV-brain-games__flanker-arrow {
        align-items: center;
        background: transparent;
        box-shadow: none;
        color: #6b7280;
        display: flex;
        flex: 0 0 auto;
        justify-content: center;
        min-width: 34px;
    }

    .UFOV-brain-games__flanker-arrow svg {
        display: block;
        height: clamp(34px, 12vw, 56px);
        width: clamp(34px, 12vw, 56px);
    }

    .UFOV-brain-games__flanker-actions {
        display: grid;
        gap: 8px;
        grid-template-areas:
            ". up ."
            "left . right"
            ". down .";
        grid-template-columns: repeat(3, 64px);
        justify-content: center;
        width: min(240px, 100%);
    }

    .UFOV-brain-games__flanker-button {
        align-items: center;
        aspect-ratio: 1;
        background: #111827;
        border: 0;
        border-radius: 18px;
        box-shadow: 0 12px 22px rgba(17, 24, 39, 0.18);
        color: #ffffff;
        display: flex;
        font: inherit;
        justify-content: center;
        padding: 0;
    }

    .UFOV-brain-games__flanker-button.is-left {
        grid-area: left;
    }

    .UFOV-brain-games__flanker-button.is-up {
        grid-area: up;
    }

    .UFOV-brain-games__flanker-button.is-right {
        grid-area: right;
    }

    .UFOV-brain-games__flanker-button.is-down {
        grid-area: down;
    }

    .UFOV-brain-games__flanker-button svg {
        display: block;
        height: 30px;
        width: 30px;
    }

    .UFOV-brain-games__flanker-button.is-picked {
        box-shadow: 0 0 0 6px rgba(17, 24, 39, 0.14);
    }

    .UFOV-brain-games__flanker-button.is-correct {
        box-shadow: 0 0 0 6px rgba(77, 230, 179, 0.24), 0 12px 22px rgba(17, 24, 39, 0.18);
    }

    .UFOV-brain-games__odds-board {
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        justify-self: center;
        max-width: 360px;
        width: 100%;
    }

    .UFOV-brain-games__odds-prompt {
        color: #1f2937;
        font-size: 21px;
        font-weight: 600;
        justify-self: center;
        line-height: 1.1;
        margin-bottom: 4px;
    }

    .UFOV-brain-games__odds-streak {
        color: #6b7280;
        font-size: 16px;
        font-weight: 600;
        justify-self: center;
        line-height: 1;
        margin-top: 2px;
    }

    .UFOV-brain-games__odds-card {
        align-items: center;
        aspect-ratio: 0.82;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.1);
        border-radius: 26px;
        box-shadow: 0 18px 34px rgba(31, 41, 55, 0.08);
        color: var(--brain-ink);
        display: flex;
        justify-content: center;
        min-height: 0;
        padding: 22px 16px;
        position: relative;
        transition:
            border-color 180ms ease,
            box-shadow 180ms ease,
            transform 180ms ease;
    }

    .UFOV-brain-games__odds-fraction {
        align-items: center;
        display: grid;
        gap: 12px;
        justify-items: center;
        line-height: 1;
    }

    .UFOV-brain-games__odds-number {
        color: #1f2937;
        font-size: clamp(52px, 16vw, 74px);
        font-weight: 600;
        line-height: 0.9;
    }

    .UFOV-brain-games__odds-line {
        background: rgba(31, 41, 55, 0.78);
        border-radius: 999px;
        display: block;
        height: 4px;
        width: min(18vw, 76px);
    }

    .UFOV-brain-games__odds-card.is-picked {
        border-color: rgba(31, 41, 55, 0.32);
        box-shadow: 0 20px 36px rgba(31, 41, 55, 0.12);
        transform: translateY(-2px);
    }

    .UFOV-brain-games__odds-card.is-correct {
        border-color: rgba(53, 201, 193, 0.78);
        box-shadow:
            0 0 0 6px rgba(53, 201, 193, 0.16),
            0 20px 36px rgba(31, 41, 55, 0.1);
    }

    .UFOV-brain-games__odds-card.is-picked:not(.is-correct) {
        border-color: rgba(255, 122, 102, 0.78);
        box-shadow:
            0 0 0 6px rgba(255, 122, 102, 0.14),
            0 20px 36px rgba(31, 41, 55, 0.1);
    }

    .UFOV-brain-games__turn-game,
    .UFOV-brain-games__rain-game,
    .UFOV-brain-games__order-game,
    .UFOV-brain-games__estimate-game,
    .UFOV-brain-games__catch-game {
        align-content: center;
        display: grid;
        gap: 14px;
        justify-items: center;
    }

    .UFOV-brain-games__turn-source {
        align-items: center;
        display: flex;
        justify-content: center;
        max-width: 320px;
        width: 100%;
    }

    .UFOV-brain-games__turn-source-inner {
        align-items: center;
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 28px;
        box-shadow: 0 16px 30px rgba(31, 41, 55, 0.1);
        display: flex;
        justify-content: center;
        position: relative;
        width: min(126px, 34vw);
        z-index: 1;
    }

    .UFOV-brain-games__turn-source-inner img,
    .UFOV-brain-games__turn-option img,
    .UFOV-brain-games__order-slot img,
    .UFOV-brain-games__order-item img,
    .UFOV-brain-games__catch-tile img {
        display: block;
        height: 76%;
        object-fit: contain;
        pointer-events: none;
        width: 76%;
    }

    .UFOV-brain-games__turn-source-inner svg {
        height: 62px;
        width: 62px;
    }

    .UFOV-brain-games__turn-options {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        max-width: 350px;
        width: 100%;
    }

    .UFOV-brain-games__turn-option,
    .UFOV-brain-games__rain-answer,
    .UFOV-brain-games__order-item,
    .UFOV-brain-games__estimate-card,
    .UFOV-brain-games__catch-tile {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 20px;
        box-shadow: 0 12px 22px rgba(31, 41, 55, 0.08);
        color: #1f2937;
        display: flex;
        font: inherit;
        font-weight: 600;
        justify-content: center;
        min-height: 74px;
        padding: 0;
        transition:
            background-color 140ms ease,
            box-shadow 140ms ease,
            transform 140ms ease;
    }

    .UFOV-brain-games__turn-option.is-picked,
    .UFOV-brain-games__rain-answer.is-picked,
    .UFOV-brain-games__order-item.is-picked,
    .UFOV-brain-games__estimate-card.is-picked,
    .UFOV-brain-games__catch-tile.is-picked {
        transform: translateY(-2px);
    }

    .UFOV-brain-games__turn-option.is-correct,
    .UFOV-brain-games__rain-answer.is-correct,
    .UFOV-brain-games__order-item.is-correct,
    .UFOV-brain-games__estimate-card.is-correct,
    .UFOV-brain-games__catch-tile.is-correct {
        background: #dff7ed;
        box-shadow: 0 0 0 6px rgba(36, 160, 107, 0.16), 0 12px 22px rgba(31, 41, 55, 0.08);
    }

    .UFOV-brain-games__turn-option.is-picked:not(.is-correct),
    .UFOV-brain-games__fit-option.is-picked:not(.is-correct),
    .UFOV-brain-games__rain-answer.is-picked:not(.is-correct),
    .UFOV-brain-games__order-item.is-picked:not(.is-correct),
    .UFOV-brain-games__estimate-card.is-picked:not(.is-correct),
    .UFOV-brain-games__catch-tile.is-picked:not(.is-correct) {
        background: #ffe0e5;
        box-shadow: 0 0 0 6px rgba(255, 111, 145, 0.15), 0 12px 22px rgba(31, 41, 55, 0.08);
    }

    .UFOV-brain-games__turn-options {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        max-width: 318px;
    }

    .UFOV-brain-games__turn-option {
        aspect-ratio: 1;
        border-radius: 24px;
        min-height: 0;
        overflow: hidden;
    }

    .UFOV-brain-games__turn-option img {
        height: 72%;
        transition: transform 140ms ease;
        width: 72%;
    }

    .UFOV-brain-games__rain-board {
        align-items: center;
        display: flex;
        height: 178px;
        justify-content: center;
        max-width: 350px;
        position: relative;
        width: 100%;
    }

    .UFOV-brain-games__rain-equation,
    .UFOV-brain-games__rain-drop {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 999px;
        box-shadow: 0 14px 26px rgba(31, 41, 55, 0.08);
        color: #1f2937;
        display: flex;
        font-weight: 600;
        justify-content: center;
        line-height: 1;
    }

    .UFOV-brain-games__rain-equation {
        font-size: clamp(48px, 15vw, 66px);
        height: min(148px, 42vw);
        width: min(148px, 42vw);
        z-index: 1;
    }

    .UFOV-brain-games__rain-drop {
        color: rgba(31, 41, 55, 0.34);
        font-size: 20px;
        height: 58px;
        position: absolute;
        top: 12px;
        width: 58px;
    }

    .UFOV-brain-games__rain-drop.is-left {
        left: 7%;
    }

    .UFOV-brain-games__rain-drop.is-right {
        right: 7%;
        top: 38px;
    }

    .UFOV-brain-games__rain-options {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        max-width: 350px;
        width: 100%;
    }

    .UFOV-brain-games__rain-answer {
        font-size: clamp(28px, 9vw, 38px);
        min-height: 76px;
    }

    .UFOV-brain-games__order-queue,
    .UFOV-brain-games__order-tray {
        display: grid;
        gap: 10px;
        max-width: 354px;
        width: 100%;
    }

    .UFOV-brain-games__order-queue {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .UFOV-brain-games__order-slot {
        align-items: center;
        aspect-ratio: 1;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 20px;
        box-shadow: 0 12px 22px rgba(31, 41, 55, 0.08);
        display: flex;
        justify-content: center;
        opacity: 0.58;
        position: relative;
    }

    .UFOV-brain-games__order-slot.is-current {
        box-shadow: 0 0 0 6px rgba(84, 199, 255, 0.16), 0 12px 22px rgba(31, 41, 55, 0.08);
        opacity: 1;
    }

    .UFOV-brain-games__order-slot.is-done {
        background: #dff7ed;
        opacity: 0.5;
    }

    .UFOV-brain-games__order-tray {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .UFOV-brain-games__estimate-board {
        display: grid;
        gap: 14px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        max-width: 360px;
        width: 100%;
    }

    .UFOV-brain-games__estimate-card {
        aspect-ratio: 0.84;
        border-radius: 26px;
        min-height: 0;
        overflow: hidden;
        position: relative;
    }

    .UFOV-brain-games__estimate-dot {
        background: #1f2937;
        border-radius: 999px;
        display: block;
        position: absolute;
        transform: translate(-50%, -50%);
    }

    .UFOV-brain-games__catch-grid {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        max-width: 330px;
        width: 100%;
    }

    .UFOV-brain-games__catch-tile {
        aspect-ratio: 1;
        min-height: 0;
    }

    .UFOV-brain-games__catch-tile.is-watching img {
        opacity: 0.56;
        transform: scale(0.9);
    }

    .UFOV-brain-games__catch-tile.is-revealed img {
        opacity: 1;
        transform: scale(1);
        transition: opacity 120ms ease, transform 120ms ease;
    }

    .UFOV-brain-games__expanded-game {
        align-content: center;
        display: grid;
        gap: 18px;
        justify-items: center;
        justify-self: center;
        max-width: 390px;
        width: 100%;
    }

    .UFOV-brain-games__expanded-cue {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 999px;
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.08);
        color: #1f2937;
        display: inline-flex;
        font-size: 15px;
        font-weight: 600;
        gap: 9px;
        justify-content: center;
        line-height: 1;
        min-height: 44px;
        padding: 0 16px;
    }

    .UFOV-brain-games__expanded-cue svg {
        display: block;
        height: 19px;
        width: 19px;
    }

    .UFOV-brain-games__expanded-main {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 30px;
        box-shadow: 0 18px 34px rgba(31, 41, 55, 0.08);
        color: #1f2937;
        display: flex;
        font-size: 58px;
        font-weight: 600;
        justify-content: center;
        line-height: 1;
        min-height: 148px;
        padding: 20px;
        text-align: center;
        width: min(330px, 100%);
        word-break: break-word;
    }

    .UFOV-brain-games__expanded-sequence,
    .UFOV-brain-games__expanded-memory,
    .UFOV-brain-games__expanded-routes {
        display: grid;
        gap: 10px;
        width: min(350px, 100%);
    }

    .UFOV-brain-games__expanded-sequence,
    .UFOV-brain-games__expanded-routes {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .UFOV-brain-games__expanded-routes {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .UFOV-brain-games__expanded-sequence span,
    .UFOV-brain-games__expanded-memory span,
    .UFOV-brain-games__expanded-routes span,
    .UFOV-brain-games__expanded-rule-card {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 20px;
        box-shadow: 0 12px 24px rgba(31, 41, 55, 0.08);
        color: #1f2937;
        display: flex;
        font-size: 22px;
        font-weight: 600;
        justify-content: center;
        line-height: 1;
        min-height: 72px;
        padding: 10px;
    }

    .UFOV-brain-games__expanded-memory {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(280px, 100%);
    }

    .UFOV-brain-games__expanded-memory span {
        aspect-ratio: 1;
        font-size: 30px;
        min-height: 0;
    }

    .UFOV-brain-games__expanded-memory:not(.is-previewing) span {
        color: #8b94a5;
    }

    .UFOV-brain-games__expanded-rule-card {
        display: grid;
        gap: 16px;
        min-height: 168px;
        width: min(312px, 100%);
    }

    .UFOV-brain-games__expanded-rule-card > span {
        color: #1f2937;
        font-size: 17px;
        font-weight: 600;
    }

    .UFOV-brain-games__expanded-rule-card > div {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
    }

    .UFOV-brain-games__expanded-routes span {
        min-height: 82px;
    }

    .UFOV-brain-games__expanded-options {
        display: grid;
        gap: 11px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: min(350px, 100%);
    }

    .UFOV-brain-games__expanded-options.is-grid-answer {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        width: min(330px, 100%);
    }

    .UFOV-brain-games__expanded-options button {
        align-items: center;
        background: #ffffff;
        border: 1px solid rgba(31, 41, 55, 0.08);
        border-radius: 22px;
        box-shadow: 0 12px 22px rgba(31, 41, 55, 0.08);
        color: #1f2937;
        display: inline-flex;
        font: inherit;
        font-size: 18px;
        font-weight: 600;
        justify-content: center;
        line-height: 1;
        min-height: 64px;
        padding: 8px 10px;
        transition: background-color 140ms ease, box-shadow 140ms ease, opacity 140ms ease, transform 140ms ease;
    }

    .UFOV-brain-games__expanded-ready {
        align-items: center;
        background: #111827;
        border: 0;
        border-radius: 999px;
        box-shadow: 0 16px 28px rgba(17, 24, 39, 0.16);
        color: #ffffff;
        display: inline-flex;
        font: inherit;
        font-size: 18px;
        font-weight: 600;
        justify-content: center;
        min-height: 58px;
        padding: 0 34px;
    }

    .UFOV-brain-games__expanded-options.is-grid-answer button {
        aspect-ratio: 1;
        min-height: 0;
        padding: 0;
    }

    .UFOV-brain-games__expanded-options button:disabled {
        opacity: 0.72;
    }

    .UFOV-brain-games__expanded-options button.is-correct,
    .UFOV-brain-games__expanded-options button.is-answer {
        background: #e4f8ef;
        box-shadow: 0 0 0 5px rgba(34, 184, 120, 0.16), 0 12px 22px rgba(31, 41, 55, 0.08);
        color: #176d4a;
    }

    .UFOV-brain-games__expanded-options button.is-wrong {
        background: #ffe8ee;
        box-shadow: 0 0 0 5px rgba(255, 111, 145, 0.14), 0 12px 22px rgba(31, 41, 55, 0.08);
        color: #9f2d48;
    }

    .UFOV-brain-games__expanded-shape {
        background: var(--shape-color);
        display: block;
        height: 34px;
        width: 34px;
    }

    .UFOV-brain-games__expanded-options.is-grid-answer .UFOV-brain-games__expanded-shape {
        height: 30px;
        width: 30px;
    }

    .UFOV-brain-games__expanded-shape.is-circle {
        border-radius: 999px;
    }

    .UFOV-brain-games__expanded-shape.is-square {
        border-radius: 10px;
    }

    .UFOV-brain-games__expanded-shape.is-diamond {
        border-radius: 9px;
        transform: rotate(45deg);
    }

    .UFOV-brain-games__expanded-shape.is-triangle {
        background: transparent;
        border-bottom: 34px solid var(--shape-color);
        border-left: 19px solid transparent;
        border-right: 19px solid transparent;
        height: 0;
        width: 0;
    }

    .UFOV-brain-games__expanded-options.is-grid-answer .UFOV-brain-games__expanded-shape.is-triangle {
        border-bottom-width: 30px;
        border-left-width: 17px;
        border-right-width: 17px;
    }

    .UFOV-brain-games__path-streak,
    .UFOV-brain-games__streak-number,
    .UFOV-brain-games__odds-streak {
        display: none;
    }

    .UFOV-brain-games__trail-board {
        background: #ffffff;
        border: 0;
        box-shadow: 0 14px 28px rgba(38, 48, 79, 0.08);
    }

    .UFOV-brain-games__trail-board line {
        stroke: var(--brain-blue);
        stroke-width: 3;
    }

    .UFOV-brain-games__trail-board button {
        background: var(--brain-purple);
        box-shadow: 0 10px 18px rgba(84, 199, 255, 0.18);
        font-weight: 600;
    }

    .UFOV-brain-games__trail-board button.is-next {
        background: var(--brain-yellow);
        box-shadow: 0 0 0 7px rgba(255, 180, 84, 0.22);
        color: var(--brain-ink);
    }

    .UFOV-brain-games__trail-board button.is-done {
        background: #cdf8ea;
        color: #1d705a;
    }

    .UFOV-brain-games__tutorial-backdrop {
        align-items: center;
        background: rgba(38, 48, 79, 0.26);
        display: flex;
        inset: 0;
        justify-content: center;
        padding: 22px;
        position: absolute;
        z-index: 20;
    }

    .UFOV-brain-games__tutorial {
        background: #ffffff;
        border: 1px solid rgba(38, 48, 79, 0.08);
        border-radius: 28px;
        box-shadow: 0 28px 60px rgba(38, 48, 79, 0.2);
        color: var(--brain-ink);
        display: grid;
        gap: 14px;
        max-width: 340px;
        padding: 22px;
        width: 100%;
    }

    .UFOV-brain-games__tutorial-icon {
        align-items: center;
        background: #f8fafc;
        border: 1px solid #e6eaf2;
        border-radius: 18px;
        box-shadow: 0 10px 22px rgba(38, 48, 79, 0.08);
        color: var(--brain-ink);
        display: inline-flex;
        height: 46px;
        justify-content: center;
        width: 46px;
    }

    .UFOV-brain-games__tutorial strong {
        font-size: 21px;
        font-weight: 600;
        line-height: 1.05;
    }

    .UFOV-brain-games__tutorial ol {
        display: grid;
        gap: 8px;
        margin: 0;
        padding-left: 22px;
    }

    .UFOV-brain-games__tutorial li {
        color: #556079;
        font-size: 14px;
        line-height: 1.28;
    }

    .UFOV-brain-games__tutorial button {
        background: var(--brain-ink);
        border: 0;
        border-radius: 999px;
        color: #ffffff;
        font: inherit;
        font-weight: 600;
        min-height: 48px;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__screen,
    .UFOV-brain-games__screen.is-color-blind-mode {
        --brain-pink: #cc79a7;
        --brain-orange: #e69f00;
        --brain-yellow: #f0e442;
        --brain-green: #009e73;
        --brain-blue: #0072b2;
        --brain-purple: #56b4e9;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__play.is-good,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__play.is-good {
        --play-glow: rgba(0, 114, 178, 0.38);
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__play.is-miss,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__play.is-miss {
        --play-glow: rgba(230, 159, 0, 0.34);
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-lit,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-picked,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__sequence-pad.is-lit,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-lit,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-picked,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__sequence-pad.is-lit {
        background: #ffffff;
        box-shadow:
            0 0 0 6px rgba(0, 114, 178, 0.17),
            0 18px 30px rgba(38, 48, 79, 0.14);
        color: #ffffff;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-lit::after,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-picked::after,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-lit::after,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-picked::after {
        background: #0072b2;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__sequence-pad.is-lit span,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__sequence-pad.is-lit span {
        background: #0072b2;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-lit,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-picked,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-lit,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-picked {
        background: #0072b2;
        color: #ffffff;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-correct,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__search-grid button.is-target,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__odd-grid button.is-target,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__path-cell.is-picked,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__trail-grid button.is-done,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__turn-option.is-correct,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__rain-answer.is-correct,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__fit-option.is-correct,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__order-item.is-correct,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__estimate-card.is-correct,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__catch-tile.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__search-grid button.is-target,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__odd-grid button.is-target,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__path-cell.is-picked,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__trail-grid button.is-done,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__turn-option.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__rain-answer.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__fit-option.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__order-item.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__estimate-card.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__catch-tile.is-correct {
        background: #d8eef8;
        border-color: rgba(0, 114, 178, 0.26);
        box-shadow: 0 0 0 5px rgba(0, 114, 178, 0.18);
        color: #11324a;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-wrong,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__search-grid button.is-picked:not(.is-target),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__odd-grid button.is-picked:not(.is-target),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__path-cell.is-failed,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__trail-grid button.is-missed,
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__turn-option.is-picked:not(.is-correct),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__rain-answer.is-picked:not(.is-correct),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__fit-option.is-picked:not(.is-correct),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__order-item.is-picked:not(.is-correct),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__estimate-card.is-picked:not(.is-correct),
    .UFOV-game.is-color-blind-mode .UFOV-brain-games__catch-tile.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__matrix-cell.is-wrong,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__search-grid button.is-picked:not(.is-target),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__odd-grid button.is-picked:not(.is-target),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__path-cell.is-failed,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__trail-grid button.is-missed,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__turn-option.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__rain-answer.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__fit-option.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__order-item.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__estimate-card.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__catch-tile.is-picked:not(.is-correct) {
        background: #fff1c4;
        border-color: rgba(230, 159, 0, 0.32);
        box-shadow: 0 0 0 5px rgba(230, 159, 0, 0.2);
        color: #3f2f08;
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__flanker-button.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__flanker-button.is-correct {
        box-shadow:
            0 0 0 6px rgba(0, 114, 178, 0.22),
            0 12px 22px rgba(17, 24, 39, 0.18);
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__odds-card.is-correct,
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__odds-card.is-correct {
        border-color: rgba(0, 114, 178, 0.74);
        box-shadow:
            0 0 0 6px rgba(0, 114, 178, 0.16),
            0 20px 36px rgba(31, 41, 55, 0.1);
    }

    .UFOV-game.is-color-blind-mode .UFOV-brain-games__odds-card.is-picked:not(.is-correct),
    .UFOV-brain-games__screen.is-color-blind-mode .UFOV-brain-games__odds-card.is-picked:not(.is-correct) {
        border-color: rgba(230, 159, 0, 0.78);
        box-shadow:
            0 0 0 6px rgba(230, 159, 0, 0.16),
            0 20px 36px rgba(31, 41, 55, 0.1);
    }

    @media (max-width: 400px), (max-height: 740px) {
        .UFOV-brain-games__screen {
            gap: 10px;
            padding:
                calc(env(safe-area-inset-top, 0px) + 10px)
                14px
                max(14px, calc(env(safe-area-inset-bottom, 0px) + 14px));
        }

        .UFOV-brain-games__play {
            border-radius: 0;
            padding: 0;
        }

        .UFOV-brain-games__memory-grid,
        .UFOV-brain-games__matrix,
        .UFOV-brain-games__sequence-grid,
        .UFOV-brain-games__odd-grid,
        .UFOV-brain-games__flanker-row,
        .UFOV-brain-games__odds-board {
            gap: 6px;
        }

        .UFOV-brain-games__odds-card {
            border-radius: 22px;
            padding: 18px 12px;
        }

        .UFOV-brain-games__odds-number {
            font-size: clamp(46px, 15vw, 64px);
        }

    }

    ${DistinctGameStyles}
    ${QualityGameStyles}

    .UFOV-brain-games__game-cue {
        color: #53627a;
        font-size: 17px;
        font-weight: 600;
        justify-self: center;
        line-height: 1.25;
        max-width: 340px;
        text-align: center;
    }

    .UFOV-brain-games__flanker-row {
        display: grid;
        gap: clamp(8px, 3vw, 16px);
        grid-template-columns: repeat(5, minmax(38px, 48px));
        justify-content: center;
        justify-self: center;
        margin-inline: auto;
        width: auto;
    }

    .UFOV-brain-games__flanker-arrow {
        min-width: 0;
        width: 100%;
    }

    .UFOV-brain-games__turn-game {
        gap: 14px;
        width: min(350px, 100%);
    }

    .UFOV-brain-games__turn-source {
        background: transparent;
        border: 0;
        box-shadow: none;
        height: 136px;
        max-width: 172px;
        overflow: hidden;
    }

    .UFOV-brain-games__turn-cue {
        color: #64748b;
        font-size: 15px;
        font-weight: 600;
        line-height: 20px;
        min-height: 20px;
        text-align: center;
    }

    .UFOV-brain-games__turn-options {
        gap: 10px;
        max-width: 326px;
    }

    .UFOV-brain-games__turn-option {
        background: #ffffff;
        border: 2px solid transparent;
        border-radius: 20px;
        overflow: hidden;
    }

    .UFOV-brain-games__turn-option:disabled {
        opacity: 1;
    }

    .UFOV-brain-games__turn-option.is-correct {
        border-color: #24a06b;
    }

    .UFOV-brain-games__turn-option.is-picked:not(.is-correct) {
        border-color: #e5484d;
    }

    .UFOV-brain-games__turn-option:not(:disabled):active {
        transform: scale(0.96);
    }

    .UFOV-brain-games__voxel-view {
        height: 100%;
        min-height: 0;
        pointer-events: none;
        width: 100%;
    }

    .UFOV-brain-games__voxel-view canvas {
        display: block;
        height: 100%;
        width: 100%;
    }

    .UFOV-brain-games__turn-option .UFOV-brain-games__voxel-view {
        height: 100%;
        width: 100%;
    }

    .UFOV-brain-games__play button:not(:disabled) {
        transition:
            scale 400ms ease,
            transform 180ms ease,
            background-color 180ms ease,
            border-color 180ms ease,
            box-shadow 180ms ease,
            color 180ms ease,
            opacity 180ms ease;
    }

    @media (hover: hover) {
        .UFOV-brain-games__play button:not(:disabled):hover {
            scale: 1.03;
        }
    }

    .UFOV-brain-games__play button:not(:disabled):active {
        scale: 0.9;
    }

    .UFOV-brain-games__play .UFOV-brain-games__sequence-pad:not(:disabled) {
        transition:
            scale 90ms ease-out,
            background-color 160ms ease,
            border-color 160ms ease,
            box-shadow 160ms ease;
    }

    @media (hover: hover) {
        .UFOV-brain-games__play .UFOV-brain-games__sequence-pad:not(:disabled):hover {
            scale: 1.01;
        }
    }

    .UFOV-brain-games__play .UFOV-brain-games__sequence-pad:not(:disabled):active {
        scale: 0.92;
        transition-duration: 55ms;
    }

    @keyframes UFOV-brain-button-press {
        0%, 100% { scale: 1; }
        48% { scale: 0.9; }
    }
`;
